<template>
  <div id="subscriptions">
    <router-link v-if="!isActive" to="/payment">
      <b-button class="spnod-admin__form--button mb-2" size="sm">Subscribe</b-button>
    </router-link>
    <AdminTableContainer
      :users="localUsers"
      :headers="headers"
      :options="options" />
  </div>
</template>

<script>
import moment from 'moment'
import { cloneDeep } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import AdminTableContainer from '../../components/AdminTableContainer'

export default {
  name: 'ManageSubscription',
  components: { AdminTableContainer },
  data() {
    return {
      localUsers: {},
      options: {
        sortable: true,
        actions: ['subscriptionEdit']
      }
    }
  },
  computed: {
    ...mapGetters(['users', 'getActiveSubscription', 'getMyInfo']),
    isMobile() { return window.innerWidth < 768 },
    headers() {
      let result
      if (this.isMobile) {
        result = ['name', 'status']
      } else {
        result = ['name', 'planName', 'status', 'due', 'setToExpire', 'price']
      }
      return result
    },
    isActive() { return this.getActiveSubscription && this.getActiveSubscription.status === 'active' }
  },
  methods: {
    ...mapActions(['loadSubscriptions', 'setSubscriptionToEdit'])
  },
  mounted: async function () {
    await this.loadSubscriptions()
    this.setSubscriptionToEdit()
    const usersClone = cloneDeep(this.users)
    usersClone.data.forEach(p => {
      p.status = p.status.charAt(0).toUpperCase() + p.status.substr(1)
      p.name = p.metadata.name ? p.metadata.name : this.getMyInfo.name
      p.planName = p.plan.nickname
      p.price = `$${p.plan.amount / 100}`
      p.setToExpire = p.cancel_at_period_end ? 'Yes' : 'No'
      if (!p.cancel_at_period_end) {
        p.due = moment.unix(p.current_period_end).format('MM/DD/YYYY')
      } else {
        p.ends_on = moment.unix(p.current_period_end).format('MM/DD/YYYY')
      }
    })
    this.localUsers = usersClone
  }
}
</script>

<style scoped>
#subscriptions {
  /*max-width: 500px;*/
}
</style>



// WEBPACK FOOTER //
// src/app/Pages/ManageSubscription/ManageSubscription.vue?1326d0c6